module.exports = __webpack_public_path__ + "static/media/funnel_data_sample_en.21562cf2.png";